// 初期Swiper設定
let swiper = null;

// Swiperを初期化またはリセットする関数
function initializeSwiper(slidesPerView) {
  if (swiper) {
    swiper.destroy(true, true); // 既存のSwiperインスタンスを破棄
  }
  swiper = new Swiper('.swiper', {
    loop: true,
    speed: 1000,
    slidesPerView: slidesPerView,
    spaceBetween: 10,
    centeredSlides: true,
    initialSlide: 0,
    followFinger: false,

    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  updateImageSizes();
}

// メディアクエリの設定
const mediaQueryMobile = window.matchMedia('(max-width: 767px)');
const mediaQueryMidium = window.matchMedia('(max-width: 1200px)');
const mediaQueryLarge = window.matchMedia('(max-width: 1600px)');

// メディアクエリの状態に基づいてSwiperを設定
function handleMediaQueryChange() {
  if (mediaQueryMobile.matches) {
    // 携帯サイズのとき
    initializeSwiper(1.3);
  } else if (mediaQueryMidium.matches) {
    // 1200px以下のとき
    initializeSwiper(2.5);
  } else if (mediaQueryLarge.matches) {
    // 1600px以下のとき
    initializeSwiper(3.3);
  } else {
    // デスクトップサイズのとき
    initializeSwiper(3.3);
  }
}

// 初期ロード時にメディアクエリをチェック
handleMediaQueryChange();

// メディアクエリの変更を監視
mediaQueryMobile.addListener(handleMediaQueryChange);
mediaQueryLarge.addListener(handleMediaQueryChange);

// 画像の高さを幅と同じにする関数
function updateImageSizes() {
  const images = document.querySelectorAll('.swiper-slide img');
  images.forEach(img => {
    const width = img.clientWidth;
    img.style.height = `${width * 0.5625}px`;
  });
}


// ウィンドウリサイズ時に高さを更新
window.addEventListener('resize', updateImageSizes);


// DOMの読み込み完了時の処理
document.addEventListener('DOMContentLoaded', () => {
  // 画像のリサイズ処理
  updateImageSizes();

  // 画像の表示を制御
  const images = document.querySelectorAll('.swiper-slide img');
  images.forEach((img) => {
    img.classList.add('loaded'); // ロード完了後にクラスを追加
  });
});
